import { render, staticRenderFns } from "./EmpresasNew.vue?vue&type=template&id=42d801f8&"
import script from "./EmpresasNew.vue?vue&type=script&lang=js&"
export * from "./EmpresasNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports